/* eslint-disable max-len */
/* eslint-disable camelcase */
export const video_interview = {
  'micro-test': 'Микрофонды тексеру',
  'indicator-reacts': 'Шеңберлі индикатор сыртқы дыбыстарға реакция береді. Оны толығымен толтыр',
  'if-indicator-donot-reacts': 'Егер индикатор реакция бермесе немесе браузер қосымша рұқсат сұраса, "Қолжетімділік беруді" басыңыз',
  'interview-finished': 'Сұхбат аяқталды. Рақмет!',
  'answer-successfuly-sent': 'Жауаптар сәтті жіберілді',
  'prepering-to-recording': 'Сізде дайындыққа {seconds} сек. бар. "Жаза бастауды" басқан соң, жазба басталады.',
  'current-step': '{maxStep} ішінен {currentStep} сұрақ',
  'question-text': 'Сұрақтың мәтіні:',
  'show-question': 'Сұрақты көрсету',
  'test-record': 'Сынақ жазба',
  'make-test-record': 'Сынақ жазба жасаңыз: камераға қарап бірдеңе айтыңыз. Жауаптарыңыз қалай болатынын көресіз',
  'start-recording': 'Жаза бастау',
  'stop-recording': 'Жаза бастау',
  're-record': 'Жаза бастау',
  'turn-on-the-camera': 'Камераны қосыңыз!',
  'selection-stages': 'Іріктеу кезеңдері',
  questionnaire: 'Сауалнама',
  'video-interview': 'Сауалнама',
};
